import React from 'react';
import { useNavigate } from 'react-router-dom';
import FileUpload from '../components/FileUpload';

const UploadPage = () => {
  const navigate = useNavigate();

  const handleUploadSuccess = (jobId, configChoice) => {
    navigate(`/results/${jobId}`, { state: { configChoice } });
  };

  return (
    <div className="upload-page">
      <div className="page-header">
        <h1>EWS Financial Tracking AI-Assistant</h1>
        <p>Upload a project document (PDF) to analyze its Early Warning System components</p>
      </div>
      
      <div className="upload-container">
        <FileUpload onUploadSuccess={handleUploadSuccess} />
      </div>
      
      <div className="instructions">
        <h3>How it works:</h3>
        <ol>
          <li>Upload a project document in PDF format</li>
          <li>Select the appropriate configuration (CREWS, AF, GCF, GEF, WB, SOFF, IADB, ADB, AFDB )</li>
          <li>The system will analyze the document and extract EWS components</li>
          <li>View detailed analysis of budget allocations by EWS pillar</li>
        </ol>

        <h3>What you'll get:</h3>
        <ul>
          <li>Total project funding</li>
          <li>Total project funding breakdown into EWS and non-EWS compenents</li>
          <li>EWS component identification and categorization</li>
          <li>Budget allocation per EWS pillar</li>
          <li>Detailed justifications for each allocation</li>
          <li>CSV file with pillars budget allocations</li>
        </ul>
      </div>
    </div>
  );
};

export default UploadPage;
